import {
  Card,
  Col,
  Form,
  Input,
  Layout,
  Row,
  Select,
  Switch,
  TreeSelect,
} from "antd";
import { toNumber } from "lodash";
import { useEffect, useMemo, useReducer, useState } from "react";
import { useNavigate } from "react-router-dom";
import FormActionButton from "src/components/common/FormActionButton";
import { messages } from "src/constants/messages";
import { apiCaller, cancelListToken } from "src/util/apiCaller";
import { MessageStatusError } from "src/util/MessageStatus";

const FormItem = Form.Item;

const listCap = [
  { cap: 1, name: "Sở Ban Ngành" },
  { cap: 2, name: "Ngành dọc" },
  { cap: 3, name: "Huyện" },
  { cap: 4, name: "Xã" },
];

const initialState = {
  tenDonVi: "",
  isDonVi: false,
  maDinhDanh: "",
  thuTu: "",
  loaiDonVi: "",
  parentId: 0,
};

const PhongBanForm = ({ status }: any) => {
  const { isActive } = status;
  const navigate = useNavigate();
  const [fieldTouch, setFieldTouch] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [loadingButtonClose, setLoadingButtonClose] = useState(false);
  const [treeDataPB, setTreeDataPB] = useState();
  const [form] = Form.useForm();
  const { tenDonVi, isDonVi, thuTu, maDinhDanh } = initialState;
  const [cap, setCap] = useState(1);
  const [parentId, setParentId] = useState(undefined);

  const { validateFields, resetFields } = form;
  const [, forceUpdate] = useReducer((x) => x + 1, 0);

  useEffect(() => {
    if (isActive) {
      getListData();
      forceUpdate();
    } else {
      navigate("/error/401");
    }
  }, []);

  useEffect(() => {
    return () => {
      cancelListToken(["gettreealluser"]);
    };
  }, []);

  /**
   * getListData : Lấy danh sách phòng ban
   * @memberof  PhongBanForm
   */
  const getListData = async () => {
    const configAPI = {
      url: "api/phongbans/gettreealluser",
      method: "GET",
      value: "",
      apiType: "DETAIL",
      getName: "gettreealluser",
    };
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        setTreeDataPB(response.data);
      } else {
        MessageStatusError(toNumber(response?.status));
      }
    } catch (error) {
      error;

      // Xử lý lỗi khi lưu dữ liệu không thành công
    }
  };

  /**
   * goBack : quay lại trang danh sách
   * @memberof  PhongBanForm
   */
  const goBack = () => {
    navigate("/quan-tri/phong-ban");
  };

  /**
   * save : lưu dữu liệu
   * @memberof  PhongBanForm
   */
  const save = () => {
    validateFields()
      .then((values) => {
        setLoadingButton(true);
        saveData(values, false);
      })
      .catch(() => {
        setLoadingButton(false);
      });
  };

  /**
   * saveAndClose: Lưu và đóng
   * @memberof PhongBanForm
   */
  const saveAndClose = () => {
    validateFields()
      .then((values) => {
        setLoadingButton(true);
        saveData(values, true);
      })
      .catch(() => {
        setLoadingButton(false);
      });
  };

  /**
   * saveData : lưu dữu liệu
   * @memberof  PhongBanForm
   */
  const saveData = async (values: any, saveQuit = false) => {
    const newData = { ...values.phongBan };
    newData.level = cap;
    newData.loaiDonVi = cap;
    newData.isSuDung = true;
    newData.isBanTiepDan = false;
    try {
      const configAPI = {
        url: `api/phongbans/create`,
        method: "POST",
        data: newData,
        apiType: "ADD",
        isShowMessage: true,
      };
      const response = await apiCaller(configAPI);
      if (response?.status === 200 || response?.status === 201) {
        if (saveQuit) {
          goBack();
          setLoadingButtonClose(false);
        } else {
          resetFields();
          setFieldTouch(false);
          setLoadingButton(false);
        }
      } else {
        MessageStatusError(toNumber(response?.status));
        setLoadingButton(false);
      }
    } catch (error) {
      setLoadingButton(false);
    }
  };

  /**
   * treeDataSelect: Vòng lặp tìm treeData
   * @memberof PhongBanForm
   */
  const treeDataSelect = useMemo(() => {
    const loop = (data: any) =>
      data?.map((item: any) => {
        if (item.children) {
          return {
            title: item.tenDonVi,
            value: item.id,
            key: item.id,
            children: loop(item.children),
          };
        }
        return {
          title: item.tenDonVi,
          value: item.id,
          key: item.id,
        };
      });
    return loop(treeDataPB);
  }, [treeDataPB]);

  return (
    <Layout>
      <div style={{ display: "flex" }}>
        <Col md={12}>
          <h2 style={{ color: "black", fontSize: 20, marginTop: 10 }}>
            Thêm mới phòng ban
          </h2>
        </Col>
      </div>
      <Card>
        <Form
          className="form-container wrapper-content-inner"
          layout="vertical"
          form={form}
          name="chucvu-control"
          onFieldsChange={() => setFieldTouch(true)}
        >
          <Row gutter={24}>
            <Col md={12} xs={24}>
              <FormItem
                layout="vertical"
                label="Tên đơn vị/Phòng ban"
                name={["phongBan", "tenDonVi"]}
                rules={[
                  {
                    type: "string",
                    required: true,
                    message: messages.ERROR_REQUIRED,
                  },
                ]}
                initialValue={tenDonVi}
              >
                <Input
                  name="tenDonVi"
                  className="input-item"
                  placeholder="Nhập tên phòng ban"
                />
              </FormItem>
            </Col>
            <Col md={12} xs={24}>
              <FormItem
                label="Loại đơn vị"
                name={["phongBan", "cap"]}
                initialValue={cap}
              >
                <Select
                  // name="cap"
                  onChange={(e) => setCap(e)}
                  placeholder="Chọn loại đơn vị"
                  style={{ width: "100%" }}
                  options={listCap}
                  fieldNames={{ label: "name", value: "cap" }}
                ></Select>
              </FormItem>
            </Col>
            <Col md={12} xs={24}>
              <FormItem
                layout="vertical"
                name={["phongBan", "parentId"]}
                label= "Thuộc đơn vị"
                rules={[
                  {
                    required: true,
                    message: messages.ERROR_REQUIRED,
                  },
                ]}
                initialValue={parentId}
              >
                <TreeSelect
                  allowClear
                  showSearch
                  // name="parentId"
                  treeDefaultExpandAll={false}
                  placeholder="Vui lòng chọn"
                  onChange={(e) => setParentId(e)}
                  treeData={treeDataSelect}
                  treeNodeFilterProp="title"
                  style={{ width: "100%" }}
                  dropdownStyle={{ overflow: "auto" }}
                />
              </FormItem>
            </Col>
            <Col md={12} xs={24}>
              <FormItem
                label="Thứ tự"
                name={["phongBan", "thuTu"]}
                initialValue={thuTu}
              >
                <Input name="thuTu" placeholder="Thứ tự" type="number" />
              </FormItem>
            </Col>
            <Col md={12} xs={24}>
              <FormItem
                label="Mã định danh"
                name={["phongBan", "maDinhDanh"]}
                initialValue={maDinhDanh}
                rules={[
                  {
                    type: "string",
                    required: true,
                    message: "Vui lòng nhập mã định Danh",
                  },
                ]}
              >
                <Input
                  name="maDinhDanh"
                  placeholder="Mã định danh"
                  className="input-item"
                />
              </FormItem>
            </Col>
            <Col md={12} xs={24}>
              <FormItem
                label="Đơn vị"
                name={["phongBan", "isDonVi"]}
                valuePropName="checked"
                initialValue={isDonVi}
              >
                <Switch />
              </FormItem>
            </Col>
          </Row>
          <hr/>
          <FormActionButton
            goBack={goBack}
            saveAndClose={saveAndClose}
            disabled={fieldTouch}
            save={save}
            loadingButton={loadingButton}
            loadingButtonClose={loadingButtonClose}
          />
        </Form>
      </Card>
    </Layout>
  );
};

export default PhongBanForm;
